import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const SelectPackage = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Fetch all packages on component mount
  useEffect(() => {
    fetchPackages();
  }, []);
  
  // Function to fetch packages from the API
  const fetchPackages = async () => {
    try {
      setLoading(true);
      const response = await fetch("https://ecom-22-fe6311cae608.herokuapp.com/packages");
      if (!response.ok) {
        throw new Error("Failed to fetch packages");
      }
      const data = await response.json();
      setPackages(data);
      setError(null);
    } catch (err) {
      console.error("Error fetching packages:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  
  // Helper function to get package features
  const getPackageFeatures = (pkg) => {
    const features = [];
    if (pkg.pointOne) features.push(pkg.pointOne);
    if (pkg.pointTwo) features.push(pkg.pointTwo);
    if (pkg.pointThree) features.push(pkg.pointThree);
    if (pkg.pointFour) features.push(pkg.pointFour);
    if (pkg.pointFive) features.push(pkg.pointFive);
    if (pkg.pointSix) features.push(pkg.pointSix);
    if (pkg.pointSeven) features.push(pkg.pointSeven);
    if (pkg.pointEight) features.push(pkg.pointEight);
    if (pkg.pointNine) features.push(pkg.pointNine);
    if (pkg.pointTen) features.push(pkg.pointTen);
    return features;
  };
  
  // Icons for features
  const featureIcons = [
    "bi bi-check-circle-fill text-success",
    "bi bi-shield-check text-primary", 
    "bi bi-lightning-charge-fill text-warning",
    "bi bi-star-fill text-info",
    "bi bi-image text-danger",
    "bi bi-flag-fill text-secondary"
  ];

  return (
    <>
      {/* Custom CSS for enhanced styling */}
      <style jsx>{`
        .pricing-card {
          transition: all 0.3s ease;
          border: none;
          border-radius: 15px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        
        .pricing-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
        }
        
        .pricing-header {
          background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
          color: white;
          padding: 2rem 1.5rem;
          text-align: center;
          position: relative;
        }
        
        .pricing-card.featured .pricing-header {
          background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
        }
        
        .popular-badge {
          position: absolute;
          top: 15px;
          right: 15px;
          background: rgba(255, 255, 255, 0.2);
          color: white;
          padding: 0.25rem 0.75rem;
          border-radius: 20px;
          font-size: 0.75rem;
          font-weight: 600;
          backdrop-filter: blur(4px);
        }
        
        .price-tag {
          font-size: 3rem;
          font-weight: 700;
          margin: 1rem 0;
        }
        
        .price-period {
          font-size: 1rem;
          font-weight: 400;
          opacity: 0.8;
        }
        
        .pricing-features {
          padding: 1.5rem;
          flex-grow: 1;
        }
        
        .pricing-features ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .pricing-features li {
          padding: 0.75rem 0;
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          display: flex;
          align-items: center;
        }
        
        .pricing-features li:last-child {
          border-bottom: none;
        }
        
        .pricing-features li i {
          margin-right: 0.75rem;
          font-size: 1.25rem;
        }
        
        .pricing-footer {
          padding: 1.5rem;
          text-align: center;
        }
        
        .btn-pricing {
          padding: 0.75rem 2rem;
          border-radius: 50px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1px;
          transition: all 0.3s ease;
        }
        
        .btn-pricing:hover {
          transform: scale(1.05);
        }
        
        .section-title h2 {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
          position: relative;
          display: inline-block;
        }
        
        .section-title h2:after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 0;
          width: 70px;
          height: 4px;
          background: linear-gradient(90deg, #6a11cb 0%, #2575fc 100%);
          border-radius: 2px;
        }
        
        .section-title p {
          font-size: 1.25rem;
          color: #6c757d;
          margin-bottom: 3rem;
        }
        
        .section-title p span {
          color: #6a11cb;
          font-weight: 600;
        }
        
        .error-container {
          background: #fff;
          border-radius: 15px;
          padding: 2rem;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
          text-align: center;
        }
        
        .loading-spinner {
          display: inline-block;
          width: 3rem;
          height: 3rem;
          border: 4px solid rgba(0, 0, 0, 0.1);
          border-radius: 50%;
          border-top-color: #6a11cb;
          animation: spin 1s ease-in-out infinite;
        }
        
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>

      <section id="pricing" className="py-5 bg-light">
        <div className="container">
          <div className="section-title text-center mb-5">
            <h2>Pricing Plans</h2>
            <p>
              Choose from our popular
              <span> packages</span>
            </p>
          </div>
          
          {loading ? (
            <div className="text-center py-5">
              <div className="loading-spinner mb-3"></div>
              <p className="text-muted">Loading amazing packages for you...</p>
            </div>
          ) : error ? (
            <div className="error-container max-w-2xl mx-auto">
              <div className="text-danger mb-3">
                <i className="bi bi-exclamation-triangle-fill fs-1"></i>
              </div>
              <h4 className="mb-3">Oops! Something went wrong</h4>
              <p className="text-muted mb-4">We couldn't load the packages. Please try again later.</p>
              <button 
                className="btn btn-outline-danger px-4"
                onClick={fetchPackages}
              >
                <i className="bi bi-arrow-clockwise me-2"></i>
                Try Again
              </button>
            </div>
          ) : (
            <div className="row g-4">
              {packages.map((pkg, index) => (
                <div
                  key={pkg._id || index}
                  className="col-lg-4 col-md-6"
                >
                  <div className={`pricing-card ${pkg.isPopular ? 'featured' : ''}`}>
                    <div className="pricing-header">
                      {pkg.isPopular && <span className="popular-badge">Most Popular</span>}
                      <h3 className="mb-1">{pkg.packageName}</h3>
                      <div className="price-tag">
                        ${pkg.price}
                        <span className="price-period">/USD</span>
                      </div>
                    </div>
                    
                    <div className="pricing-features">
                      <ul>
                        {getPackageFeatures(pkg).map((feature, featIndex) => (
                          <li key={featIndex}>
                            <i className={featureIcons[featIndex % featureIcons.length]}></i>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                    
                    <div className="pricing-footer">
                      <Link 
                        to={pkg.price === 0 ? "/signup" : `/buy/${pkg._id}`} 
                        className={`btn btn-pricing btn-lg w-100 ${pkg.price === 0 ? 'btn-success' : pkg.isPopular ? 'btn-danger' : 'btn-primary'}`}
                      >
                        {pkg.price === 0 ? (
                          <>
                            <i className="bi bi-lightning-charge-fill me-2"></i>
                            Start Now
                          </>
                        ) : (
                          <>
                            <i className="bi bi-cart-fill me-2"></i>
                            Buy Now
                          </>
                        )}
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default SelectPackage;